import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../images/logo.png";
import "./component.css";

function Navbar() {
    const location = useLocation();
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem("adminToken");
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openGroup, setOpenGroup] = useState("");

    const isActive = (path) => location.pathname === path;
    const isGroupActive = (paths) => paths.some((path) => location.pathname.includes(path));

    const handleLogout = () => {
        localStorage.removeItem("adminToken");
        setIsMenuOpen(false);
        setOpenGroup("");
        navigate("/");
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => {
        setIsMenuOpen(false);
        setOpenGroup("");
    };
    const toggleGroup = (groupKey) => setOpenGroup((prev) => (prev === groupKey ? "" : groupKey));

    useEffect(() => {
        setOpenGroup("");
    }, [location.pathname]);

    const groups = [
        {
            key: "drmtlgy-shipstation",
            title: "DRMTLGY ShipStation",
            activeKeys: ["slackOrderstatus", "clientOrderStatus"],
            items: [
                { to: "/slackOrderstatus", label: "Single Order Status" },
                { to: "/clientOrderStatus", label: "Bulk Order Status" },
            ],
        },
        {
            key: "drmtlgy-shopify",
            title: "DRMTLGY Shopify",
            activeKeys: ["drmtlyOrderByDate", "drmtlgyBulkStatus", "drmtlgyReconciliation"],
            items: [
                { to: "/drmtlyOrderByDate", label: "Date-wise Orders" },
                { to: "/drmtlgyBulkStatus", label: "Bulk Order Status" },
                { to: "/drmtlgyReconciliation", label: "Reconciliation" },
            ],
        },
        {
            key: "kitsch",
            title: "Kitsch",
            activeKeys: ["kitschOrderStatus", "kitschTagOrderStatus"],
            items: [
                { to: "/kitschOrderStatus", label: "Single Order Status" },
                { to: "/kitschTagOrderStatus", label: "Tag Bulk Status" },
            ],
        },
    ];

    if (isAdmin) {
        groups.push({
            key: "dih-shopify",
            title: "DIH Shopify",
            activeKeys: ["dihOrderByDate", "dihBulkStatus"],
            items: [
                { to: "/dihOrderByDate", label: "Date-wise Orders" },
                { to: "/dihBulkStatus", label: "Bulk Order Status" },
            ],
        });
    }

    return (
        <nav className="navbar navbar-expand-lg app-navbar">
            <div className="container-fluid">
                <div className="navbar-brand">
                    <Link to="/" onClick={closeMenu}>
                        <img src={Logo} alt="Company Logo" className="navbar-logo" style={{ height: "40px" }} />
                    </Link>
                </div>

                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleMenu}
                    aria-label="Toggle navigation"
                    aria-expanded={isMenuOpen}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="navbarNav">
                    <ul className="navbar-nav mx-auto text-center app-nav-groups">
                        {groups.map((group) => (
                            <li key={group.key} className="nav-item app-nav-group">
                                <button
                                    type="button"
                                    className={`nav-link app-group-toggle ${isGroupActive(group.activeKeys) ? "active" : ""}`}
                                    onClick={() => toggleGroup(group.key)}
                                >
                                    {group.title}
                                    <span className={`app-group-caret ${openGroup === group.key ? "open" : ""}`}>▾</span>
                                </button>
                                <div className={`app-group-menu ${openGroup === group.key ? "show" : ""}`}>
                                    {group.items.map((item) => (
                                        <Link
                                            key={item.to}
                                            className={`dropdown-item app-group-item ${isActive(item.to) ? "active fw-bold" : ""}`}
                                            to={item.to}
                                            onClick={closeMenu}
                                        >
                                            {item.label}
                                        </Link>
                                    ))}
                                </div>
                            </li>
                        ))}
                        <li className="nav-item">
                            <Link
                                className={`nav-link app-link-pill ${location.pathname.includes("/kitschOrderDetailUpdate") ? "active fw-bold" : ""}`}
                                to="/kitschOrderDetailUpdate"
                                onClick={closeMenu}
                            >
                                ShipStation Detail Update
                            </Link>
                        </li>
                    </ul>

                    <div className="d-flex justify-content-center mt-3 mt-lg-0">
                        {isAdmin ? (
                            <button onClick={handleLogout} className="btn btn-outline-danger btn-sm">
                                Logout
                            </button>
                        ) : (
                            <Link to="/admin/login" className="btn btn-outline-primary btn-sm" onClick={closeMenu}>
                                Admin Login
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
